import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import classNames from 'classnames/bind';
import React from 'react';
import { SkeletonContext } from '../../contexts/SkeletonContext.js';
import styles from './SkeletonArea.module.scss.js';

var cx = _bindInstanceProperty(classNames).call(classNames, styles);
/**
 * 스켈레톤 노출여부를 제어하는 유틸성 컴포넌트
 *
 * `SkeletonCard`, `SkeletonListImage`, `SkeletonListSymbol`, `SkeletonListText`만을 children으로 가집니다.
 *
 * ```tsx
 * <SkeletonArea isPage={false} isShow={true}>
 *      <SkeletonListText />
 *      <SkeletonListImage imagePosition="left" />
 *      <SkeletonListSymbol />
 *      <SkeletonCard mobile={2} tablet={4} desktop={6} height={120} />
 * </SkeletonArea>
 * ```
 */
function SkeletonArea(_ref) {
  var _ref$isPage = _ref.isPage,
    isPage = _ref$isPage === void 0 ? false : _ref$isPage,
    _ref$isShow = _ref.isShow,
    isShow = _ref$isShow === void 0 ? true : _ref$isShow,
    _ref$hasOpacity = _ref.hasOpacity,
    hasOpacity = _ref$hasOpacity === void 0 ? false : _ref$hasOpacity,
    containerClassName = _ref.containerClassName,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(SkeletonContext.Provider, {
    value: {
      isPage: isPage
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('article', containerClassName, {
      'type-page': isPage,
      'is-alpha50': hasOpacity
    }),
    style: {
      display: isShow ? 'block' : 'none'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uB85C\uB529\uC911"), children));
}

export { SkeletonArea as default };
